import { api } from "./api";
import { UtensilsCrossed, ShoppingBag, Building2 } from "lucide-react";

export const SECTIONS = {
  restaurants: { path: "/restaurants", icon: UtensilsCrossed, key: "restaurants" },
  shopping: { path: "/shopping", icon: ShoppingBag, key: "shopping" },
  directory: { path: "/directory", icon: Building2, key: "directory" },
};

const get = (url, params) => api.get(url, { params }).then((r) => r.data);

export const directoryApi = {
  categories: (section) => get("/directory/categories", { section }),
  neighborhoods: (section) => get("/directory/neighborhoods", { section }),
  cuisines: (section) => get("/directory/cuisines", { section }),
  businesses: (params) => get("/directory/businesses", params),
  business: (slug) => get(`/directory/businesses/${encodeURIComponent(slug)}`),
};

export const localName = (obj, lang) => (obj && (obj[lang] || obj.en)) || "";

export const formatAddress = (a) =>
  a ? [[a.housenumber, a.street].filter(Boolean).join(" "), a.suburb, a.city, a.postcode].filter(Boolean).join(", ") : "";

export const websiteHref = (w) => (/^https?:\/\//i.test(w) ? w : `https://${w}`);
